export default __webpack_public_path__ + "img/sagoo/seq/sagoo2_1500.jpg";